import { BrowserModule } from "@angular/platform-browser";
import { NgModule, Provider, forwardRef, APP_INITIALIZER } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AgGridModule } from "ag-grid-angular";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatCardModule } from "@angular/material/card";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule } from "@angular/material/menu";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatTreeModule } from "@angular/material/tree";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
//import { } from "@angular/material/"

import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker'

import { NgxPayPalModule } from "ngx-paypal";

//import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

import { AppComponent } from "./app.component";
import { NavMenuComponent } from "./tools/nav-menu/nav-menu.component";

import { HomeComponent } from "./modules/home/home.component";
import { AccountRegisterComponent } from "./modules/account/register/account-register.component";
import { AccountLoginComponent } from "./modules/account/login/account-login.component";
import { PowerBIEmbeddedComponent } from "./modules/powerbi/embedded/powerbi-embedded.component";
import { InteractiveComponent } from "./modules/interactive/interactive.component";
import { SubscriptionComponent } from "./modules/subscription/subscription.component";
import { SubscriptionManagementComponent } from "./modules/subscription/subscriptionmanagement.component";
import { AdminComponent } from "./modules/admin/admin.component";
import { PurchaseSubscriptionComponent } from "./modules/purchase-subscription/purchase-subscription.component";
import { UpdateSubscriptionComponent } from "./modules/update-subscription/update-subscription.component";
import { ResetPasswordComponent } from "./modules/account/reset-password/reset-password.component";
import { ConfirmEmailComponent } from "./modules/account/confirm-email/confirm-email.component";
import { ReportExportsComponent } from "./modules/report-exports/report-exports.component";

import { CounterComponent } from "./modules/counter/counter.component";
import { FetchDataComponent } from "./modules/fetch-data/fetch-data.component";
import { ApiInterceptor } from "./tools/intercepters/ApiIntercepter";
import { SafePipe } from "./tools/transforms/safepipe";

import { AppInitService } from "./tools/app-init.service";

import { CopyInteractiveDialogComponent } from "./dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import { ConfirmDialogComponent } from "./dialogs/confirm-dialog/confirm-dialog.component";
import { AdmLayoutsComponent } from "./modules/adm-layouts/adm-layouts.component";
import { PreferencesComponent } from "./modules/preferences/preferences.component";
import { AdmLayoutDialogComponent } from "./dialogs/adm-layout-dialog/adm-layout-dialog.component";
import { AdmConnectionDialogComponent } from "./dialogs/adm-connection-dialog/adm-connection-dialog.component";
import { AdmTableDialogComponent } from "./dialogs/adm-table-dialog/adm-table-dialog.component";
import { AdmFieldGroupDialogComponent } from "./dialogs/adm-field-group-dialog/adm-field-group-dialog.component";
import { DodEditDialogComponent } from "./dialogs/dod-edit-dialog/dod-edit-dialog.component";
import { DodRenameDialogComponent } from "./dialogs/dod-rename-dialog/dod-rename-dialog.component";
import { AdmColumnDialogComponent } from "./dialogs/adm-column-dialog/adm-column-dialog.component";
import { AdmRelationshipDialogComponent } from "./dialogs/adm-relationship-dialog/adm-relationship-dialog.component";
import { AdmFlattenedColumnDialogComponent } from "./dialogs/adm-flattened-column-dialog/adm-flattened-column-dialog.component";
import { AdmRerouteLineageDialogComponent } from "./dialogs/adm-reroute-lineage-dialog/adm-reroute-lineage-dialog.component";
import { AdmFilterPointDialogComponent } from "./dialogs/adm-filter-point-dialog/adm-filter-point-dialog.component";
import { AdmGroupDialogComponent } from "./dialogs/adm-group-dialog/adm-group-dialog.component";
import { MessageDialogComponent } from "./dialogs/message-dialog/message-dialog.component";
import { HtmlMessageDialogComponent } from "./dialogs/html-message-dialog/html-message-dialog.component";
import { TextEditDialogComponent } from "./dialogs/text-edit-dialog/text-edit-dialog.component";
import { InputEditDialogComponent } from "./dialogs/input-edit-dialog/input-edit-dialog.component";
import { DropDownSelectDialogComponent } from "./dialogs/dropdown-select-dialog/dropdown-select-dialog.component";
import { ShareInteractiveDialogComponent } from "./dialogs/share-interactive-dialog/share-interactive-dialog.component";
import { LoginDialogComponent } from "./dialogs/login-dialog/login-dialog.component";
import { RegisterDialogComponent } from "./dialogs/register-dialog/register-dialog.component";
import { AddSubscriptionUserDialogComponent } from "./dialogs/add-subscription-user-dialog/add-subscription-user-dialog.component";
import { InteractMenuDialogComponent } from "./dialogs/interact-menu-dialog/interact-menu-dialog.component";

import { EditInteractiveDialogComponent } from "./dialogs/admin/edit-interactive-dialog/edit-interactive-dialog.component";
import { EditInteractiveSubscriptionsDialogComponent } from "./dialogs/admin/edit-interactive-subscription-dialog/edit-interactive-subscription-dialog.component";
import { EditSubLevelsDialogComponent } from "./dialogs/admin/edit-subscription-level-dialog/edit-subscription-level-dialog.component";
import { EditSubPricesDialogComponent } from "./dialogs/admin/edit-subscription-price-dialog/edit-subscription-price-dialog.component";
import { EditUnpaidOrderDialogComponent } from "./dialogs/admin/edit-unpaid-order-dialog/edit-unpaid-order-dialog.component";
import { EditSubscriptionDialogComponent } from "./dialogs/admin/edit-subscription-dialog/edit-subscription-dialog.component";
import { EditCouponsDialogComponent } from "./dialogs/admin/edit-coupon-dialog/edit-coupon-dialog.component";
import { EditCouponLevelDialogComponent } from "./dialogs/admin/edit-coupon-level-dialog/edit-coupon-level-dialog.component";
import { EditCouponLevelsDialogComponent } from "./dialogs/admin/edit-coupon-levels-dialog/edit-coupon-levels-dialog.component";
import { EditXmlaSubscriptionsDialogComponent } from "./dialogs/admin/edit-xmla-subscription-dialog/edit-xmla-subscription-dialog.component";
import { EditXmlaSubscriptionLevelsDialogComponent } from "./dialogs/admin/edit-xmla-subscription-level-dialog/edit-xmla-subscription-level-dialog.component";
import { EditXmlaSubscriptionPricesDialogComponent } from "./dialogs/admin/edit-xmla-subscription-price-dialog/edit-xmla-subscription-price-dialog.component";
import { EditInteractiveFilterDialogComponent } from "./dialogs/edit-interactive-filter-dialog/edit-interactive-filter-dialog.component";
import { EditInteractiveBookmarkDialogComponent } from "./dialogs/edit-interactive-bookmark-dialog/edit-interactive-bookmark-dialog.component";
import { EditUserDialogComponent } from "./dialogs/admin/edit-user-dialog/edit-user-dialog.component";
import { EditInteractReportsDialogComponent } from "./dialogs/admin/edit-interactive-report-dialog/edit-interactive-report-dialog.component";
import { ReportExportDialogComponent } from "./dialogs/report-export-dialog/report-export-dialog.component";
import { EditPartnerEmbedDialogComponent } from './dialogs/admin/edit-partner-embed-dialog/edit-partner-embed-dialog.component';

import { PowerBiReportExportStart } from './modules/powerbi/report-export/powerbi-report-export-start.component';
import { PowerBiReportExport } from './modules/powerbi/report-export/powerbi-report-export.component';

import { SimpleGridComponent } from "./elements/simple-grid/simple-grid.component";
import { ShareEditorComponent } from "./elements/share-editor/share-editor.component";
import { TreeEditorComponent } from "./elements/tree-editor/tree-editor.component";

import { UserTypeFilterPipe } from "./pipes/UserType.Pipe";

import { PowerbiEmbedComponent } from './elements/powerbi-embed/powerbi-embed.component';
import { CommonModule } from "@angular/common";
import { PartnerEmbedComponent } from './modules/powerbi/partner-embed/partner-embed.component';

import { TestPageComponent } from "./modules/test-page/test-page.component";
import {
  SelfServiceAnalyticsHomeComponent
} from "./elements/self-service-analytics-home/self-service-analytics-home.component";
import { AdminReportExportConfigComponent } from "./modules/admin/controls/admin-report-export-config/admin-report-export-config.component";
import { AdminAdmDefinitionComponent } from "./modules/admin/controls/admin-adm-definition/admin-adm-definition.component";
import { AdminDodDefinitionComponent } from "./modules/admin/controls/admin-dod-definition/admin-dod-definition.component";
import { AdminDodTransferComponent } from "./modules/admin/controls/admin-dod-transfer/admin-dod-transfer.component";
import { AdminAdmTransferComponent } from "./modules/admin/controls/admin-adm-transfer/admin-adm-transfer.component";
import { AdminAdmFlattenCopyComponent } from "./modules/admin/controls/admin-adm-flatten-copy/admin-adm-flatten-copy.component";
import { AdminAdmTransferReviewComponent } from "./modules/admin/controls/admin-adm-transfer-review/admin-adm-transfer-review.component";
import { AdmStepsComponent } from "./modules/admin/controls/adm-steps/adm-steps.component";
import { AdminAdmGroupsComponent } from "./modules/admin/controls/admin-adm-groups/admin-adm-groups.component";
import { EditReportSourceDialogComponent } from "./dialogs/admin/edit-report-source-dialog/edit-report-source-dialog.component";
import { EditReportStandardTypeDialogComponent } from "./dialogs/admin/edit-report-standard-type-dialog/edit-report-standard-type-dialog.component";
import { EditReportEmbeddedTypeDialogComponent } from "./dialogs/admin/edit-report-embedded-type-dialog/edit-report-embedded-type-dialog.component";
import { EditReportSubscriptionTypeDialogComponent } from "./dialogs/admin/edit-report-subscription-type-dialog/edit-report-subscription-type-dialog.component";
import { EditReportSubscriptionLevelDialogComponent } from "./dialogs/admin/edit-report-subscription-level-dialog/edit-report-subscription-level-dialog.component";
import { EditReportSubscriptionPriceDialogComponent } from "./dialogs/admin/edit-report-subscription-price-dialog/edit-report-subscription-price-dialog.component";
import { ReportSubscriptionsComponent } from "./modules/report-subscriptions/report-subscriptions.component";
import { WidgetsComponent } from "./modules/widgets/widgets.component";
import { PowerbiReportEmbedComponent } from "./elements/powerbi-report-embed/powerbi-report-embed.component";
import { ReportStandardLayoutPropsDialogComponent } from "./dialogs/report-standard-layout-props-dialog/report-standard-layout-props-dialog.component";
import { ReportEmbeddedExportPropsDialogComponent } from "./dialogs/report-embedded-export-props-dialog/report-embedded-export-props-dialog.component";
import { PowerBiReportHomeComponent } from "./elements/powerbi-report-home/powerbi-report-home.component";
import { PowerBiWidgetHomeComponent } from "./elements/powerbi-widget-home/powerbi-widget-home.component";
import { EmbedReportComponent } from "./modules/embed-report/embed-report.component";
import { PrintReportComponent } from "./modules/print-report/print-report.component";
import { SortByLastUpdated } from "./pipes/ReportExport.Sort";
import { EmbedReportPublicComponent } from "./modules/embed-report-public/embed-report-public.component";
import {PowerBIEmbedModule} from 'powerbi-client-angular';
import {PrintOnDemandDialogComponent} from './dialogs/print-on-demand-dialog/print-on-demand-dialog.component';
import {MatListModule} from '@angular/material/list';
import {PodStatusSnackbarComponent} from './elements/pod-status-snackbar/pod-status-snackbar.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {PrintOnDemandLayoutDialogComponent} from './dialogs/print-on-demand-layout-dialog/print-on-demand-layout-dialog.component';
import {ReportLayoutsComponent} from './modules/report-layouts/report-layouts.component';
import {RecurringPodDialogComponent} from './dialogs/recurring-pod-dialog/recurring-pod-dialog.component';
import {OccupationFilterEditorComponent} from './elements/filter-editor/occupation-filter-editor.component';
import {IndustryFilterEditorComponent} from './elements/filter-editor/industry-filter-editor.component';
import {DataOnDemandDialogComponent} from './dialogs/data-on-demand-dialog/data-on-demand-dialog.component';
import {DataOnDemandLayoutDialogComponent} from './dialogs/data-on-demand-layout-dialog/data-on-demand-layout-dialog.component';
import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';
import {JobDepartmentSearchComponent} from './elements/filter-editor/job-department-search.component';
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {JobSenioritySearchComponent} from './elements/filter-editor/job-seniority-search.component';
import {CompanySearchComponent} from './elements/filter-editor/company-search.component';
import {FullTitleSearchComponent} from './elements/filter-editor/full-title-search/full-title-search.component';
import {TitleSearchComponent} from './elements/filter-editor/title-search.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {RecurringDodDialogComponent} from './dialogs/recurring-dod-dialog/recurring-dod-dialog.component';
import {DataLayoutsComponent} from './modules/data-layouts/data-layouts.component';
import {LocationFilterEditorComponent} from './elements/filter-editor/location-filter.component';
import {MetroGroupFilterEditorComponent} from './elements/filter-editor/metro-group-filter.component';
import {FilterEditorDialogComponent} from './dialogs/filter-editor-dialog/filter-editor-dialog.component';
import {PreFilterEditorDialogComponent} from './dialogs/pre-filter-editor-dialog/pre-filter-editor-dialog.component';
import {PreFilterManagementComponent} from './modules/subscription/controls/pre-filter-management/pre-filter-management.component';
import {PreFilterComponent} from "./modules/pre-filter/pre-filter.component";
import {EducationInstitutionSearchComponent} from './elements/filter-editor/education-institution-search.component';
import {DataOnDemandEndPointConfigDialogComponent} from './dialogs/data-on-demand-end-point-config-dialog/data-on-demand-end-point-config-dialog.component';
import {AttributeTaxonomyFilterEditorComponent} from './elements/filter-editor/attribute-taxonomy-filter.component';

@NgModule({
  exports: [
    MatSnackBarModule,
    MatSelectModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatTabsModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatExpansionModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatSelectModule,
    MatProgressBarModule,
    MatFormFieldModule,
    DragDropModule,
  ],
  imports: [
    CommonModule,
    DragDropModule,
  ],
  declarations: []
})
export class MaterialModule {}

export function initializeApp(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.Init();
  };
}

export const API_INTERCEPTOR_PROVIDER: Provider = {
  provide: HTTP_INTERCEPTORS,
  useExisting: forwardRef(() => ApiInterceptor),
  multi: true,
};

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        SafePipe,
        AccountRegisterComponent,
        AccountLoginComponent,
        PowerBIEmbeddedComponent,
        InteractiveComponent,
        AdminComponent,
        SubscriptionComponent,
        SubscriptionManagementComponent,
        PurchaseSubscriptionComponent,
        UpdateSubscriptionComponent,
        ResetPasswordComponent,
        ConfirmEmailComponent,
        ReportExportsComponent,
        CopyInteractiveDialogComponent,
        ConfirmDialogComponent,
        AdmLayoutsComponent,
        PreferencesComponent,
        AdmLayoutDialogComponent,
        AdmConnectionDialogComponent,
        AdmTableDialogComponent,
        AdmFieldGroupDialogComponent,
        DodEditDialogComponent,
        DodRenameDialogComponent,
        AdmColumnDialogComponent,
        AdmRelationshipDialogComponent,
        AdmFlattenedColumnDialogComponent,
        AdmRerouteLineageDialogComponent,
        AdmFilterPointDialogComponent,
        AdmGroupDialogComponent,
        MessageDialogComponent,
        HtmlMessageDialogComponent,
        TextEditDialogComponent,
        InputEditDialogComponent,
        DropDownSelectDialogComponent,
        ShareInteractiveDialogComponent,
        LoginDialogComponent,
        RegisterDialogComponent,
        AddSubscriptionUserDialogComponent,
        InteractMenuDialogComponent,
        EditInteractiveDialogComponent,
        EditInteractiveSubscriptionsDialogComponent,
        EditSubLevelsDialogComponent,
        EditSubPricesDialogComponent,
        EditCouponsDialogComponent,
        EditCouponLevelDialogComponent,
        EditCouponLevelsDialogComponent,
        EditUnpaidOrderDialogComponent,
        EditSubscriptionDialogComponent,
        EditXmlaSubscriptionsDialogComponent,
        EditXmlaSubscriptionLevelsDialogComponent,
        EditXmlaSubscriptionPricesDialogComponent,
        EditInteractiveFilterDialogComponent,
        EditInteractiveBookmarkDialogComponent,
        EditUserDialogComponent,
        EditInteractReportsDialogComponent,
        ReportExportDialogComponent,
        EditPartnerEmbedDialogComponent,
        EditReportSourceDialogComponent,
        EditReportStandardTypeDialogComponent,
        EditReportEmbeddedTypeDialogComponent,
        EditReportSubscriptionTypeDialogComponent,
        EditReportSubscriptionLevelDialogComponent,
        EditReportSubscriptionPriceDialogComponent,
        ReportSubscriptionsComponent,
        WidgetsComponent,
        PowerbiReportEmbedComponent,
        PowerBiReportExportStart,
        PowerBiReportExport,
        ReportStandardLayoutPropsDialogComponent,
        ReportEmbeddedExportPropsDialogComponent,
        PowerBiReportHomeComponent,
        PowerBiWidgetHomeComponent,
        SimpleGridComponent,
        ShareEditorComponent,
        TreeEditorComponent,
        CounterComponent,
        FetchDataComponent,
        UserTypeFilterPipe,
        PowerbiEmbedComponent,
        PartnerEmbedComponent,
        SelfServiceAnalyticsHomeComponent,
        AdminReportExportConfigComponent,
        AdminAdmDefinitionComponent,
        AdminDodDefinitionComponent,
        AdminDodTransferComponent,
    AdminAdmTransferComponent,
    AdminAdmFlattenCopyComponent,
    AdminAdmTransferReviewComponent,
    AdmStepsComponent,
        AdminAdmGroupsComponent,
        EmbedReportComponent,
        EmbedReportPublicComponent,
        PrintReportComponent,
        TestPageComponent,
        SortByLastUpdated,

        PrintOnDemandDialogComponent,
        PrintOnDemandLayoutDialogComponent,
        RecurringPodDialogComponent,
        PodStatusSnackbarComponent,

        ReportLayoutsComponent,

        DataOnDemandDialogComponent,
        DataOnDemandLayoutDialogComponent,
        RecurringDodDialogComponent,
        DataLayoutsComponent,

        OccupationFilterEditorComponent,
        IndustryFilterEditorComponent,

        JobDepartmentSearchComponent,
        JobSenioritySearchComponent,
        CompanySearchComponent,
        TitleSearchComponent,
        FullTitleSearchComponent,
        AttributeTaxonomyFilterEditorComponent,
        LocationFilterEditorComponent,
        MetroGroupFilterEditorComponent,
        EducationInstitutionSearchComponent,

        FilterEditorDialogComponent,
        PreFilterEditorDialogComponent,
        PreFilterManagementComponent,
        DataOnDemandEndPointConfigDialogComponent,

        PreFilterComponent,

    ],
  imports: [
    BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ClipboardModule,
    NgxPayPalModule,
    AgGridModule,
    MatSelectModule,
    MatSelectInfiniteScrollModule,
    NgxMatColorPickerModule,
    PowerBIEmbedModule,
    RouterModule.forRoot([
      {path: '', component: HomeComponent, pathMatch: 'full'},
      {path: 'register', component: AccountRegisterComponent},
      {path: 'login', component: AccountLoginComponent},
      {path: 'interactives', component: InteractiveComponent},
      {path: 'admin', component: AdminComponent},
      {
        path: 'powerbi-embedded/:interactId/:interactType/:actionType/:filterId/:preFilterId/:bookmarkId/:reportId',
        component: PowerBIEmbeddedComponent,
      },
      {path: 'subscription', component: SubscriptionComponent},
      {
        path: 'subscriptionmanagement/:subscriptionId',
        component: SubscriptionManagementComponent,
      },
      {
        path: 'subscription-purchase/:packagetype/:subscriptiontype/:subscriptionlevel',
        component: PurchaseSubscriptionComponent,
      },
      {
        path: 'subscription-purchase/:packagetype/:subscriptiontype/:subscriptionlevel/:couponCode',
        component: PurchaseSubscriptionComponent,
      },
      {
        path: 'update-subscription/:subscriptionId/:updateType',
        component: UpdateSubscriptionComponent,
      },
      {path: 'resetpassword/:resetToken', component: ResetPasswordComponent},
      {
        path: 'confirmemail/:emailAddress/:confirmationCode',
        component: ConfirmEmailComponent,
      },
      {path: 'report-exports', component: ReportExportsComponent},
      {path: 'report-export-internal-start/:reportInteractiveId/:reportExportId/:reportPage', component: PowerBiReportExportStart},
      {path: 'report-export-internal-process/:reportInteractiveId/:reportExportId/:reportPage', component: PowerBiReportExport},
      {path: 'counter', component: CounterComponent},
      {path: 'fetch-data', component: FetchDataComponent},
      {path: 'partner-embed/:partnerApiKey', component: PartnerEmbedComponent},
      {path: 'test-page', component: TestPageComponent},
      {path: 'report-subscriptions', component: ReportSubscriptionsComponent},
      {path: 'widgets', component: WidgetsComponent},
      {path: 'report-embed/:embedToken', component: EmbedReportComponent},
      {path: 'report-embed-public/:embedToken', component: EmbedReportPublicComponent},
      {path: 'report-print/:reportExportId', component: PrintReportComponent},
      {path: 'report-layouts', component: ReportLayoutsComponent},
      {path: 'dod-layouts', component: DataLayoutsComponent},
      {path: 'adms', component: AdmLayoutsComponent},
      {path: 'preferences', component: PreferencesComponent},
      {path: 'pre-filters', component: PreFilterComponent},
      {path: 'reese-chat', loadChildren: () => import('./modules/reese-chat/reese-chat.module').then(m => m.ReeseChatModule)}
    ]),
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    MatProgressSpinnerModule,
    CdkFixedSizeVirtualScroll,
    MatChipsModule,
  ],
    providers: [
        ApiInterceptor,
        API_INTERCEPTOR_PROVIDER,
        AppInitService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppInitService],
            multi: true,
      },
      {
        provide: MAT_COLOR_FORMATS,
        useValue: NGX_MAT_COLOR_FORMATS
      }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
